
(function(){
  var root = document.getElementById('tapex');
  if (!root) return;
  var box = root.querySelector('.tx-buybox');
  var rows = Array.prototype.slice.call(root.querySelectorAll('.tx-row'));
  var moreBtn = document.getElementById('tx-more');
  var upsell = document.getElementById('tx-upsell');
  var variantInput = document.getElementById('tx-variant');
  var planInput = document.getElementById('tx-plan');
  var atc = document.getElementById('tx-atc');
  var qtyInput = document.getElementById('tx-qty');
  var form = document.getElementById('tx-form');
  var stickyBar = document.getElementById('tx-sticky');
  var stickyCta = document.getElementById('tx-sticky-cta');
  var stickySize = document.getElementById('tx-sticky-size');
  var stickyTitle = document.getElementById('tx-sticky-title');
  var upsellPrice = document.getElementById('tx-upsell-price');
  var shipLine = document.getElementById('tx-ship-line');
  var billLine = document.getElementById('tx-bill-line');
  var shipBase = shipLine ? shipLine.textContent : '';
  var modeBtns = root.querySelectorAll('[data-mode]');
  var FREE_SUB = parseInt(box.getAttribute('data-ship-free-sub'),10) || 7500;
  var SUB_FEE = box.getAttribute('data-ship-sub-fee') || '';
  var mode = 'once', stackOn = false, expanded = false;
  var QTY_MIN = 1, QTY_MAX = 10;
  var CUR = box.getAttribute('data-cur') || '$';
  var money = function(c){ return CUR + (c/100).toFixed(2); };
  var short = function(c){ var s=(c/100).toFixed(2); return CUR + (s.slice(-3)==='.00' ? s.slice(0,-3) : s); };
  var num = function(el,a){ return parseInt(el.getAttribute(a),10) || 0; };
  var D = '·';

  function selected(){ for (var i=0;i<rows.length;i++){ if(rows[i].classList.contains('selected')) return rows[i]; } return rows[0]; }
  function qty(){ var v=parseInt(qtyInput.value,10); if(isNaN(v)||v<QTY_MIN) v=QTY_MIN; if(v>QTY_MAX) v=QTY_MAX; return v; }
  function available(r){ return mode === 'once' || num(r,'data-apex-sub') > 0; }
  function stackOk(r){ return num(r,'data-stack-id') > 0 && (mode === 'once' || num(r,'data-stack-sub') > 0); }
  function useStack(r){ return stackOn && stackOk(r); }
  function priceOf(r){
    var s = useStack(r);
    if (mode === 'sub') return num(r, s ? 'data-stack-sub' : 'data-apex-sub');
    return num(r, s ? 'data-stack-price' : 'data-apex-price');
  }
  function fullOf(r){
    var s = useStack(r);
    if (mode === 'sub') return num(r, s ? 'data-stack-price' : 'data-apex-price');
    return num(r, s ? 'data-sep' : 'data-full');
  }
  function every(n){ return n === 1 ? 'every month' : (n === 12 ? 'every 12 months' : 'every ' + n + ' months'); }

  function layout(){
    var sel = selected();
    rows.forEach(function(r){
      var isExtra = r.classList.contains('tx-extra');
      var hide = !available(r) || (isExtra && !expanded && r !== sel);
      r.classList.toggle('tx-hidden', hide);
    });
    if (moreBtn){
      var extras = rows.filter(function(r){ return r.classList.contains('tx-extra') && available(r); });
      moreBtn.classList.toggle('tx-hidden', extras.length === 0);
      moreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      moreBtn.querySelector('span').textContent = expanded ? 'Fewer options' : 'More options';
    }
  }

  function render(){
    var sel = selected(); if (!sel) return;
    if (!available(sel)){ var fb = rows.filter(available)[0]; if (fb){ rows.forEach(function(x){ x.classList.remove('selected'); }); fb.classList.add('selected'); sel = fb; } }
    if (stackOn && !stackOk(sel)) stackOn = false;
    rows.forEach(function(r){
      var s = useStack(r), n = num(r,'data-size'), days = num(r,'data-days');
      var price = priceOf(r), full = fullOf(r);
      var t = r.querySelector('.tx-row-title'), sub = r.querySelector('.tx-row-sub'), ship = r.querySelector('.tx-row-ship');
      var name = s ? ('Alpha Stack ' + D + ' ' + n + (n === 1 ? ' Pack' : ' Packs')) : (n + (n === 1 ? ' Bottle' : ' Bottles'));
      if (n === 12 && !s) name += ' ' + D + ' Annual supply';
      t.textContent = name;
      if (mode === 'sub'){
        sub.textContent = (n === 12 ? 'Delivered once a year' : 'Delivered ' + every(n)) + ' ' + D + ' ' + r.getAttribute('data-off') + '% off';
        if (SUB_FEE){ ship.textContent = price >= FREE_SUB ? 'Free shipping' : ('Shipping ' + SUB_FEE); ship.classList.remove('tx-hidden'); } else { ship.classList.add('tx-hidden'); }
      } else {
        sub.textContent = s ? (days + ' day supply ' + D + ' ' + (n*3) + ' bottles') : (days + ' day supply ' + D + ' ' + (n*60) + ' capsules');
        ship.classList.add('tx-hidden');
      }
      r.querySelector('[data-now]').textContent = money(price);
      r.querySelector('[data-perday]').textContent = money(price/days) + '/day';
      var strike = r.querySelector('[data-strike]');
      if (full > price){ strike.textContent = money(full); strike.style.display = ''; } else { strike.style.display = 'none'; }
      var banner = r.querySelector('.tx-row-banner');
      if (banner){
        var lead = n === 12 ? 'Best value' : 'Recommended';
        banner.textContent = mode === 'sub' ? (lead + ' ' + D + ' ' + r.getAttribute('data-off') + '% off') : (lead + ' ' + D + ' Save ' + short(full - price));
      }
    });
    layout();
    var unit = priceOf(sel), n = num(sel,'data-size');
    variantInput.value = useStack(sel) ? sel.getAttribute('data-stack-id') : sel.getAttribute('data-apex-id');
    planInput.value = mode === 'sub' ? sel.getAttribute('data-plan') : '';
    var total = money(unit*qty());
    atc.textContent = (mode === 'sub' ? 'Subscribe ' : 'Pre-Order Now ') + D + ' ' + total;
    if (stickyCta) stickyCta.textContent = (mode === 'sub' ? 'Subscribe ' : 'Pre-Order ') + D + ' ' + total;
    if (stickyTitle) stickyTitle.textContent = (useStack(sel) ? 'The Alpha Stack' : 'Testosterone Apex™') + ' ' + D + (mode === 'sub' ? ' Subscribe' : ' Pre-order');
    if (stickySize){
      Array.prototype.forEach.call(stickySize.options, function(o){ var r = rows.filter(function(x){ return x.getAttribute('data-size') === o.value; })[0]; o.disabled = !r || !available(r); });
      stickySize.value = sel.getAttribute('data-size');
    }
    if (billLine) billLine.textContent = mode === 'sub' ? ('Charged ' + total + ' today, then ' + every(n) + '. Pause or cancel anytime.') : '100% money-back guarantee';
    if (shipLine) shipLine.textContent = mode === 'sub' ? 'First delivery ships with the pre-order batch. Later deliveries follow your schedule.' : shipBase;
    if (upsell && upsellPrice){
      var ok = stackOk(sel);
      upsell.disabled = !ok;
      upsell.classList.toggle('on', stackOn && ok);
      upsell.setAttribute('aria-pressed', stackOn && ok ? 'true' : 'false');
      if (!ok){
        upsellPrice.textContent = num(sel,'data-stack-id') > 0 ? 'Available as a one-time purchase' : 'Not available for this pack size';
      } else {
        var apexP = mode === 'sub' ? num(sel,'data-apex-sub') : num(sel,'data-apex-price');
        var stackP = mode === 'sub' ? num(sel,'data-stack-sub') : num(sel,'data-stack-price');
        var save = num(sel,'data-sep') - num(sel,'data-stack-price');
        upsellPrice.textContent = (stackOn ? 'Added' : '+' + money(stackP - apexP)) + (mode === 'once' && save > 0 ? ' ' + D + ' save ' + short(save) + ' vs buying separately' : '');
      }
    }
  }

  function selectSize(size){
    rows.forEach(function(x){ x.classList.toggle('selected', x.getAttribute('data-size') === String(size)); });
    render();
  }
  rows.forEach(function(r){ r.addEventListener('click', function(){ selectSize(r.getAttribute('data-size')); }); });
  if (moreBtn) moreBtn.addEventListener('click', function(){ expanded = !expanded; layout(); });

  if (upsell) upsell.addEventListener('click', function(){ if (upsell.disabled) return; stackOn = !stackOn; render(); });

  function setMode(m){
    mode = m;
    modeBtns.forEach(function(b){ var on = b.getAttribute('data-mode') === m; b.classList.toggle('active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    render();
  }
  modeBtns.forEach(function(b){ b.addEventListener('click', function(){ setMode(b.getAttribute('data-mode')); }); });

  document.getElementById('tx-qty-minus').addEventListener('click', function(){ qtyInput.value = Math.max(QTY_MIN, qty()-1); render(); });
  document.getElementById('tx-qty-plus').addEventListener('click', function(){ qtyInput.value = Math.min(QTY_MAX, qty()+1); render(); });
  qtyInput.addEventListener('change', function(){ qtyInput.value = qty(); render(); });
  qtyInput.addEventListener('input', render);

  function scrollToBuy(){ form.scrollIntoView({behavior:'smooth', block:'center'}); }
  var stackCta = document.getElementById('tx-stack-cta');
  if (stackCta) stackCta.addEventListener('click', function(){
    var sel = selected();
    if (mode === 'sub' && !stackOk(sel)) setMode('once');
    if (!stackOk(selected())) selectSize(3);
    stackOn = true; render(); scrollToBuy();
  });
  var finalCta = document.getElementById('tx-final-cta');
  if (finalCta) finalCta.addEventListener('click', scrollToBuy);
  if (stickySize) stickySize.addEventListener('change', function(){ selectSize(stickySize.value); });
  if (stickyCta) stickyCta.addEventListener('click', function(){ if (form.requestSubmit) form.requestSubmit(); else atc.click(); });

  form.addEventListener('submit', function(e){
    e.preventDefault();
    atc.disabled = true;
    var fd = new FormData(form);
    if (!fd.get('selling_plan')) fd.delete('selling_plan');
    fetch('/cart/add.js', { method:'POST', body: fd, headers: {'Accept':'application/json'} })
      .then(function(r){ return r.json(); })
      .then(function(data){
        atc.disabled = false;
        if (data.status){ alert('Could not add to cart: ' + (data.description || data.message || 'please try again.')); return; }
        if (window.Shopify && typeof window.Shopify.onItemAdded === 'function'){ window.Shopify.onItemAdded(data, true); }
        else { window.location.href = '/cart'; }
      })
      .catch(function(err){ atc.disabled = false; console.error('tapex add to cart failed', err); form.submit(); });
  });

  if (stickyBar && 'IntersectionObserver' in window){
    var shown = false;
    new IntersectionObserver(function(entries){
      var e = entries[0];
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      if (past !== shown){
        shown = past;
        stickyBar.classList.toggle('show', past);
        stickyBar.setAttribute('aria-hidden', past ? 'false' : 'true');
        stickyCta.tabIndex = past ? 0 : -1;
        if (stickySize) stickySize.tabIndex = past ? 0 : -1;
      }
    }).observe(atc);
  }

  var main = document.getElementById('tx-car-main');
  var wrap = document.getElementById('tx-car-wrap');
  var thumbs = root.querySelectorAll('.tx-car-thumb');
  var dots = root.querySelectorAll('#tx-car-dots i');
  function cur(){ for (var i=0;i<thumbs.length;i++){ if(thumbs[i].classList.contains('active')) return i; } return 0; }
  function show(i){
    if (!thumbs.length) return;
    if (i<0) i=thumbs.length-1; if (i>=thumbs.length) i=0;
    thumbs.forEach(function(t,k){ t.classList.toggle('active', k===i); });
    dots.forEach(function(d,k){ d.classList.toggle('on', k===i); });
    main.src = thumbs[i].getAttribute('data-src');
  }
  thumbs.forEach(function(t,i){ t.addEventListener('click', function(){ show(i); }); });
  var prev = document.getElementById('tx-car-prev'), next = document.getElementById('tx-car-next');
  if (prev) prev.addEventListener('click', function(){ show(cur()-1); });
  if (next) next.addEventListener('click', function(){ show(cur()+1); });
  if (wrap){
    var sx = null;
    wrap.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; }, {passive:true});
    wrap.addEventListener('touchend', function(e){ if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(cur() + (dx < 0 ? 1 : -1)); sx = null; });
  }

  var track = document.getElementById('tx-ing-track');
  function slide(dir){ if (track) track.scrollBy({left: dir * track.clientWidth * 0.82, behavior:'smooth'}); }
  var ip = document.getElementById('tx-ing-prev'), inx = document.getElementById('tx-ing-next');
  if (ip) ip.addEventListener('click', function(){ slide(-1); });
  if (inx) inx.addEventListener('click', function(){ slide(1); });

  setMode('once');
})();
